<template>
    <div v-if="series">
        <CardRowText
            :label="$t('event-category')"
            :text="idToName(series.category, CATEGORY_ITEMS)"
            :has-border-bottom="true"
        />
        <CardRowText :label="$t('event-type')" :text="idToName(series.type, TYPE_ITEMS)" :has-border-bottom="true" />
        <CardRowText
            :label="$t('is-public')"
            :text="nullBooleanToString(series.isPublic ?? undefined)"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('is-technical')"
            :text="nullBooleanToString(series.isTechnical ?? undefined)"
            :has-border-bottom="false"
        />
    </div>
</template>
<script setup lang="ts">
import CardRowText from '@/components/Card/CardRowText.vue';
import { useEventSeries } from '@/event/composables/useEventSeries';
import { idToName, nullBooleanToString } from '@/event/event';
import { CATEGORY_ITEMS, TYPE_ITEMS } from '@/event/forms/schemas';
import { computed } from 'vue';
const props = defineProps<{ seriesId: string }>();

const seriesId = computed(() => props.seriesId);
const { series } = useEventSeries(seriesId);
</script>
